import FloorLayingPattern from './FloorLayingPattern';

export default FloorLayingPattern;